import io from 'socket.io-client';

// export interface Message {
//     errcode: number | string,
//     errmsg: any,
//     data: any
// }

export default class VueWebsocket {
    constructor(url, path) {
        this.url = url;
        this.path = path;
        this.connected = false;
        this.subscribeList = [];
        this.emitList = [];
    }

    connect() {
        if (this.url == null || undefined == this.url || this.url.trim() == '') {
            throw 'Invalid url';
        }

        try {
            let opts = {
                upgrade: false,
                transports: ['websocket', 'polling'],
                reconnectionDelay: 3000,
                reconnectionDelayMax: 5000,
            };

            if (this.path) {
                opts['path'] = this.path;
            }

            this.socket = io.connect(this.url, opts);

            this.socket.on('connect', () => {
                this.connected = true;
                this.onConnect(true);
            });

            this.socket.on('connect_error', () => {
                // console.log("Connect error");
            });

            this.socket.on('disconnect', () => {
                this.connected = false;
                this.onConnect(false);
            });

            this.socket.on('reconnect', () => {
                this.connected = true;
                this.onConnect(true);
            });

            this.socket.on('reconnecting', (attemptNumber) => {
                // console.log("Reconnecting", attemptNumber);
            });

            return this;
        } catch (error) {
            throw 'Failed to establish connection';
        }
    }

    sock() {
        return this.socket;
    }

    onConnect() {

    }

    emit(event, ...args) {
        return new Promise((resolve, reject) => {
            if (!this.connected) {
                return reject('Socket not connected');
            }

            try {
                this.socket.emit(event, ...args);
                let callback = (message) => {
                    if (message.errcode == 0 || message.errcode == '0') {
                        return resolve();
                    } else {
                        return reject(message.errmsg);
                    }
                };

                return this.subscribe(event, callback);
            } catch (error) {
                return reject(error);
            }
        });
    }

    subscribe(event, callback) {
        if (!this.connected) {
            throw 'Socket not connected';
        }

        try {
            // only subscribe once
            if (-1 != this.subscribeList.indexOf(event)) {
                this.unsubscribe(event);
            }

            this.socket.on(event, callback);
            this.subscribeList.push(event);
            return;
        } catch (error) {
            throw error;
        }
    }

    unsubscribe(event) {
        try {
            let pos = this.subscribeList.indexOf(event);
            if (pos != -1) {
                this.subscribeList.splice(pos, 1);
                this.socket.removeListener(event);
            }
            return;
        } catch (error) {
            throw error;
        }
    }
}
